import React, {useEffect, useState} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

const initialArticleData = {
    erpIdno: '',
    gtin: '',
    name: '',
    vendorArticleNumber: '',
    brand: ''
};

const CreateArticleModal = (props) => {

    const [articleData, setArticleData] = useState(initialArticleData);
    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        setArticleData(initialArticleData);
        setFormErrors({});
    }, [props.visible]);

    const cancel = () => {
        setArticleData(initialArticleData);
        props.onCancel();
    };

    const setProperty = (propertyName, propertyValue) => {
        const property = {[propertyName]: propertyValue};
        setArticleData(prevArticleData => {return {...prevArticleData, ...property}});
    };

    const validate = () => {
        let complete = true;
        let formErrors = {};

        if (articleData.gtin === '') {
            formErrors['gtin'] = true;
            complete = false;
        }
        if (articleData.name === '') {
            formErrors['name'] = true;
            complete = false;
        }
        if (articleData.brand === '') {
            formErrors['brand'] = true;
            complete = false;
        }
        setFormErrors(formErrors);

        return complete;
    };

    const submit = () => {
        if (validate()) {
            props.onSubmit(articleData);
        }
    };

        return (
                <Modal isOpen={props.visible} centered={true} className={props.className}>
                    <ModalHeader>Neuer Artikel</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-lg-12">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="csModalArticleErpIdno">SAP-Nummer</label>
                                        <input type="text" className="form-control" id="csModalArticleErpIdno"
                                               onChange={(event) => setProperty('erpIdno', event.target.value)}
                                               placeholder="SAP-Nr..." required={false}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="csModalArticleGtin">GTIN*</label>
                                        <input type="text" className={"form-control " + (formErrors.gtin ? 'is-invalid' : '')} id="csModalArticleGtin"
                                               onChange={(event) => setProperty('gtin', event.target.value)}
                                               placeholder="GTIN..." required={true}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="csModalArticleName">Artikel-Bezeichnung*</label>
                                        <input type="text" className={"form-control " + (formErrors.name ? 'is-invalid' : '')} id="csModalArticleName"
                                               onChange={(event) => setProperty('name', event.target.value)}
                                               placeholder="Artikel-Bezeichnung..." required={true}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="csModalArticleVendorArticleNumber">Hersteller-Artikelnummer</label>
                                        <input type="text" className="form-control" id="csModalArticleVendorArticleNumber"
                                               onChange={(event) => setProperty('vendorArticleNumber', event.target.value)}
                                               placeholder="Hersteller-Artikelnummer..." required={false}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="csModalArticleBrand">Marke*</label>
                                        <input type="text" className={"form-control " + (formErrors.brand ? 'is-invalid' : '')} id="csModalArticleBrand"
                                               onChange={(event) => setProperty('brand', event.target.value)}
                                               placeholder="Marke..." required={true}/>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={submit}>Artikel erstellen</Button>{' '}
                        <Button color="secondary" onClick={cancel}>Abbrechen</Button>
                    </ModalFooter>
                </Modal>
        );
};

export default CreateArticleModal;



// WEBPACK FOOTER //
// ./src/admin/article/CreateArticleModal.js